export default __webpack_public_path__ + "Jaclyn Chasse.47a59d64b39080ea7983.png";